.audience-comparison-label {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.3rem;

  padding-inline-end: 1rem;
  background-color: var(--brand-grayscale-200);
  color: var(--brand-black);
  font-weight: normal;
  text-align: left;
  text-wrap: wrap;
}
